import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import { ApsServiceService } from '../aps-service.service';

@Component({
  selector: 'app-contactform',
  templateUrl: './contactform.component.html',
  styleUrls: ['./contactform.component.css']
})
export class ContactformComponent implements OnInit {

  constructor( private searchitem: ApsServiceService,private toastr: ToastrService,) { }
  token: string|undefined;
  formdata = new FormGroup({
    name: new FormControl('',Validators.required),
    location: new FormControl('',Validators.required),
    email: new FormControl('',Validators.required),
    phone: new FormControl('',Validators.required),
    message: new FormControl('',Validators.required),
    recaptchaReactive: new FormControl('',Validators.required),

 
  });
  get name(): any { return this.formdata.get('name'); }
  get location(): any { return this.formdata.get('location'); }
  get email(): any { return this.formdata.get('email'); }
  get phone(): any { return this.formdata.get('phone'); }
  get message(): any { return this.formdata.get('message'); }
 get recaptchaReactive():any{ return this.formdata.get('recaptchaReactive'); }
  ngOnInit(): void {

    this.searchitem.envelop.subscribe(
      (name: string) => {
        this.goDown2();
      }
    );

  }

  clearInputMethod1() { this.name.reset(); this.location.reset(); this.email.reset(); this.phone.reset();this.message.reset(); }

isExists(data){
  if(data !=null){
    if(data.length == 0){
      return false
    }else{
      return true
    }
  }else{
    false
  }
}

  onClickSubmit(){


    if (!this.formdata.valid) {
      this.toastr.warning("Please fill all the fields!..")

    }else{
      //console.log(this.formdata.value)
          this.searchitem.ContactResponce(this.formdata.value).subscribe((responce) => {
      if(responce.status){
        this.toastr.success(responce.msg)
        this.clearInputMethod1()  
          }else{
        this.toastr.error("Please try again!..")
      }
    })
    }


  //   if(this.isExists(data.name)){
    
  //   this.searchitem.ContactResponce(data).subscribe((responce) => {
  //     if(responce.status){
  //       alert(responce.msg)
  //       location.reload()
  //     }else{
  //       alert("Oops! Something went wrong, please try again later")
  //     }
  //   })
  // }else{
  //   this.toastr.error("error")
  // }
    

}

goDown2() {
  //this.scroller.scrollToAnchor("targetGreen");
  document.getElementById("contact").scrollIntoView({
    behavior: "smooth",
    block: "start",
    inline: "nearest"
  });
}
}
